import BybVrCard from "@Components/common/byb-ds/cards/byb-vr-card";
import MetricProgressSection from "@Components/game/progress/metric-progress-section";
import ProgressBybIqCard from "@Components/game/progress/progress-byb-iq-card";
import ProgressHeader from "@Components/game/progress/progress-header";
import ProgressTrendCard from "@Components/game/progress/progress-trend-card";
import TrainingStatsSection from "@Components/game/progress/stats/training-stats-section";
import { ProgressBackground } from "@Components/game/progress/styled-components";
import TrainingFocusSection from "@Components/game/progress/training-focus/training-focus-section";
import ContainerWrapper from "@Components/generic/container-wrapper";
import ProgressChart from "@Containers/shared/cards/progress-chart";
import { AppContext } from "@Context/common/general/context";
import { ProgressProvider, useProgress } from "@Context/game/progress/progress-context";
import MetricFilterTypes from "@Enums/MetricFilterTypes";
import { getBybIqColor } from "@Helpers/feedback";
import useI18n from "@i18n";
import { Container, Grid, Stack, Typography, useTheme } from "@mui/material";
import { useContext } from "react";

const pageId = "PROGRESS";

const ProgressContent = () => {
  const { state } = useContext(AppContext);
  const { i18n } = useI18n();
  const theme = useTheme();

  const { longTermResults, isLongTermResultsLoading, currentBybIq, isInBootcamp, isDemo } = useProgress();
  const creationTimestamp = state.user.creationDate instanceof Date ? state.user.creationDate.getTime() : state.user.creationDate;

  return (
    <Stack gap={8} paddingBottom={8}>
      <ProgressBackground />
      <ProgressHeader />

      {!isInBootcamp && !isDemo && (
        <Stack paddingX={2} gap={8}>
          <Stack gap={2}>
            <Typography variant="textLg700" color="text.primary">
              {i18n("progress.section.byb_iq")}
            </Typography>
            <Grid container spacing={2} alignItems="stretch">
              <Grid item xs={3} sx={{ display: "flex" }}>
                <ProgressBybIqCard />
              </Grid>
              <Grid item xs={3} sx={{ display: "flex" }}>
                <ProgressTrendCard />
              </Grid>
              <Grid item xs={6} sx={{ display: "flex" }}>
                <BybVrCard sx={{ paddingBottom: theme.spacing(1.5) }}>
                  <Stack gap={2}>
                    <Typography variant="text1xl400" color="text.secondary" textAlign="left">
                      {i18n("progress.section.progress-timeline")}
                    </Typography>
                    <ProgressChart
                      data={longTermResults}
                      loading={isLongTermResultsLoading}
                      height={375}
                      color={getBybIqColor(currentBybIq || 0, theme, creationTimestamp) as string}
                      chartId={MetricFilterTypes.BYB_IQ}
                      showAverageScore
                      showUnit
                    />
                  </Stack>
                </BybVrCard>
              </Grid>
            </Grid>
          </Stack>
          
          <TrainingFocusSection />

          <MetricProgressSection />

          <TrainingStatsSection />
        </Stack>
      )}
    </Stack>
  );
};

const Progress = () => {
  return (
    <ContainerWrapper id={pageId} fullHeight>
      <Container maxWidth="xl">
        <ProgressProvider>
          <ProgressContent />
        </ProgressProvider>
      </Container>
    </ContainerWrapper>
  );
};

export default Progress;
